'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

import { CONSENT_COOKIE_NAME } from '@/app/constants/cookies';
import { getCookie } from '@/app/utils/server/cookies';

const ConsentPopup = dynamic(
  () =>
    import('@/app/components/consent/popup').then((mod) => mod.ConsentPopup),
  {
    ssr: false,
  }
);

export const Consent = () => {
  const [shouldRenderConsent, setShouldRenderConsent] =
    useState<boolean>(false);

  useEffect(() => {
    getCookie(CONSENT_COOKIE_NAME).then((res) => {
      setShouldRenderConsent(!res);
    });
  }, []);

  if (!shouldRenderConsent) return null;

  return <ConsentPopup />;
};
